import { useEffect } from 'react';
import { FIRST_PAGE, PAGE_PARAM_KEYWORD } from 'data/global';
import useQueryParams from 'hooks/useQueryParams';
import { Params } from 'react-router-dom';

export default function useResetPage(
  totalPages: number,
  currentPage: string,
  pageParam: string = PAGE_PARAM_KEYWORD,
) {
  const { setQueryParam } = useQueryParams<Params>();

  useEffect(() => {
    if ((totalPages && +currentPage > totalPages) || +currentPage < 1) {
      setQueryParam(pageParam, FIRST_PAGE);
    }
  }, [totalPages, currentPage, setQueryParam, pageParam]);
}
